import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom"; // Hook para redirigir páginas

export const ProductParallax = ({ imageUrl, imageUrlSmall, data }) => {
  const history = useHistory();
  const [offsetY, setOffsetY] = useState(0);
  const [currentImageUrl, setCurrentImageUrl] = useState(imageUrl);
  const imageRef = useRef(null);

  // Estados para el modal
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (imageRef.current) {
        const rect = imageRef.current.getBoundingClientRect();
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const elementOffsetTop = scrollTop + rect.top;
        const windowHeight = window.innerHeight;

        if (scrollTop + windowHeight > elementOffsetTop && scrollTop < elementOffsetTop + rect.height) {
          const parallaxOffset = (scrollTop - elementOffsetTop) * 0.2;
          setOffsetY(parallaxOffset);
        }
      }
    };

    const handleResize = () => {
      setCurrentImageUrl(window.innerWidth <= 550 ? imageUrlSmall : imageUrl);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [imageUrl, imageUrlSmall]);

  // Guarda la posición actual antes de navegar
  const navigateToProduct = () => {
    sessionStorage.setItem("scrollPosition", window.scrollY); // Guarda la posición actual del scroll
    history.push(`/product/${data.id}`);
    window.scrollTo({ top: 0, behavior: "smooth" }); // Corrige el problema de scroll
  };
  

  // Compartir el producto con su URL específica
  const shareProduct = () => {
    const productUrl = `${window.location.origin}/product/${data.id}`;

    if (navigator.share) {
      navigator
        .share({
          title: data.title,
          text: `¡Mira este increíble producto: ${data.title}! 🚀`,
          url: productUrl,
        })
        .catch((error) => console.log("Error al compartir:", error));
    } else {
      navigator.clipboard.writeText(productUrl)
        .then(() => alert("✅ Enlace copiado al portapapeles"))
        .catch(() => alert("❌ Error al copiar."));
    }
  };

  // Enviar datos a la API
  const handleSubmit = async () => {
    if (!name || !email) {
      alert("Por favor, completa todos los campos.");
      return;
    }

    setLoading(true);

    const requestBody = {
      ProductId: data.id,
      ClientName: name,
      ClientEmail: email,
    };

    try {
      const response = await fetch("vivebackend-a5hdfhhtbphgd4ed.canadacentral-01.azurewebsites.net/api/chargeClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        alert(`✅ ${data.textModalA}, ${name}! ${data.textModalB} ${email}.`);
        setShowModal(false);
        setName("");
        setEmail("");
      } else {
        alert("❌ Hubo un problema al enviar la solicitud.");
      }
    } catch (error) {
      console.error("Error al enviar la solicitud:", error);
      alert("❌ Error al conectar con el servidor.");
    }

    setLoading(false);
  };

  return (
    <div
      ref={imageRef}
      style={{
        position: "relative",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        backgroundImage: `url(${currentImageUrl})`,
        backgroundPosition: `center ${offsetY}px`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        zIndex: 0,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          color: "#fff",
          background: "rgba(0, 0, 0, 0.3)",
          borderRadius: "20px",
          padding: "20px",
          width: "300px",
          height: "auto",
        }}
      >
        <h1 style={{ fontSize: "32px", marginBottom: "20px", fontWeight: "bold" }}>
          {data?.title || "loading..."}
        </h1>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center" }}>
          {/* Botón para ir a la página del producto */}
          <button
            style={{
              padding: "7px 15px",
              backgroundColor: "#0A3A2C",
              borderRadius: "200px",
              color: "#fff",
              border: "none",
              cursor: "pointer",
              fontSize: "16px",
              transition: "background-color 0.3s ease",
            }}
            onClick={navigateToProduct}
          >
            {data?.ButtonAbout || "loading..."}
          </button>

          {/* Botón para comprar - Abre el modal */}
          <button
            style={{
              padding: "7px 15px",
              backgroundColor: "#0A3A2C",
              borderRadius: "200px",
              color: "#fff",
              border: "none",
              cursor: "pointer",
              fontSize: "16px",
              transition: "background-color 0.3s ease",
            }}
            onClick={() => setShowModal(true)}
          >
            {data?.ButtonBuy || "loading..."}
          </button>

          {/* Botón de compartir */}
          <button
            style={{
              padding: "7px 15px",
              backgroundColor: "transparent",
              border: "1px solid #fff",
              borderRadius: "200px",
              color: "#fff",
              cursor: "pointer",
              fontSize: "16px",
              transition: "background-color 0.3s ease",
            }}
            onClick={shareProduct}
          >
            <i className="fas fa-share-alt"></i> {data?.share || "loading..."}
          </button>
        </div>
      </div>

      {/* MODAL DE PRE-COMPRA */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              width: "400px",
              textAlign: "center",
            }}
          >
            <h2 style={{ color: "#0A3A2C" }}>{data.titleModal}</h2>
            <p>{data.subTitleModal}</p>

            <input
              type="text"
              placeholder={data.placeHolderName}
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                margin: "10px 0",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
            <input
              type="email"
              placeholder={data.placeHolderEmail}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                margin: "10px 0",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />

            <button style={{
                  backgroundColor: "#0A3A2C",
                  color: "#fff",
                  padding: "10px 15px",
                  borderRadius: "5px",
                  border: "none",
                  cursor: "pointer",
                  flex: 1,
                  marginRight: "5px",
                }}  onClick={handleSubmit} disabled={loading}>
              {loading ? "Enviando..." : data.ButtonSend}
            </button>
            <button style={{
                  backgroundColor: "#ccc",
                  color: "#000",
                  padding: "10px 15px",
                  borderRadius: "5px",
                  border: "none",
                  cursor: "pointer",
                  flex: 1,
                  marginLeft: "5px",
                }} onClick={() => setShowModal(false)}>{data.ButtonClose}</button>
          </div>
        </div>
      )}
    </div>
  );
};
